import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { LANGUAGE_CODES, DEFAULT_LANGUAGE, resolveLanguage } from '@/lib/languages';

/** Build id injected by `vite.config.ts` — busts the locale cache on every deploy. */
declare const __I18N_VERSION__: string;

i18n.use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LANGUAGE.code,
        supportedLngs: LANGUAGE_CODES,
        // `currentOnly` stops i18next stripping the region from a regional code
        // and loading the base bundle instead — without it `pt-BR` would resolve
        // to `pt` and Brazilian Portuguese could never be served.
        load: 'currentOnly',
        ns: ['common'],
        defaultNS: 'common',
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${__I18N_VERSION__}`,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            // Narrow whatever the browser reports (`pt-PT`, `en-GB`, `de-AT`, …)
            // onto a language we actually ship, before i18next tries to fetch a
            // bundle for it. Paired with `load: 'currentOnly'` this guarantees
            // every requested path exists.
            convertDetectedLanguage: (lng: string) => resolveLanguage(lng).code,
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
